import { SubscriptionListEntry, Product } from 'ggApp/types/graphql';

import ActionTypes from './actionTypes';
import { Action } from './actions';

export const defaultState: FilterStateType = {
    product: undefined,
    filterItems: [],
    totalCount: 0,
};

export type FilterStateType = {
    product?: Product;
    filterItems: SubscriptionListEntry[];
    totalCount?: number;
    pageInfo?: {
        endCursor: string;
        hasNextPage: boolean;
    };
};

function reducer(state: FilterStateType = defaultState, action: Action): FilterStateType {
    switch (action.type) {
        case ActionTypes.SET_FILTER_ITEMS: {
            const { filterItems, totalCount, pageInfo } = action.payload;

            return {
                ...state,
                filterItems,
                totalCount,
                pageInfo,
            };
        }

        case ActionTypes.APPEND_FILTER_ITEMS: {
            const { filterItems, totalCount, pageInfo } = action.payload;

            return {
                ...state,
                filterItems: [...state.filterItems, ...filterItems],
                totalCount,
                pageInfo,
            };
        }

        case ActionTypes.SET_PRODUCT:
            return {
                ...state,
                product: action.payload,
            };

        case ActionTypes.DELETE_PRODUCT:
            return {
                ...state,
                product: defaultState.product,
            };

        default:
            return state;
    }
}

export default reducer;
